import { EventEmitterHelper } from '../Utility/EventEmitter';

class Root extends EventEmitterHelper {
    constructor() {
        super();
        this.setEventEmitterElement(document);
    }
}

export const root = new Root();
